import React from 'react';

interface BigPlayIconProps {
  hideBackground?: boolean;
}

export const BigPlayIcon = (props: BigPlayIconProps) => {
  return (
    <svg
      viewBox='0 0 64 64'
      width='64'
      height='64'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      {props.hideBackground ? undefined : (
        <circle cx='32' cy='32' r='32' fill='#3FA110' />
      )}
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M23.7039 21.4071V42.5919C23.7039 43.2415 24.4123 43.6363 24.9639 43.3003L42.3715 32.7079C42.9007 32.3859 42.9007 31.6159 42.3715 31.2911L24.9639 20.6987C24.4123 20.3627 23.7039 20.7603 23.7039 21.4071Z'
        stroke='white'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M32 4C47.4644 4 60 16.5384 60 32C60 47.4616 47.4644 60 32 60C16.5356 60 4 47.4616 4 32C4 16.5384 16.5356 4 32 4Z'
        stroke='white'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};
